module.exports = __webpack_public_path__ + "img/roboport-recharging.f44ab0b7.png";